const WEB_VALUE = 'web';
const ANY_VALUE = 'any';

export const isAvailablePlatform = (platform) => {
  return platform === WEB_VALUE || platform === ANY_VALUE;
};
